import { Mui } from "@osu/react-ui";

export const SectionLoader = () => (
  <Mui.Box  sx={{ mb: 2 }}>
    <Mui.Box display="flex" justifyContent="space-between" alignItems="center">
      <Mui.Skeleton variant="text" width="20%" height={28} />
      <Mui.Skeleton variant="rectangular" width={80} height={32} />
    </Mui.Box>

    {/* Description list items */}
    <Mui.Stack spacing={1} sx={{ my: 2 }}>
      <Mui.Skeleton variant="text" width="100%" height={24} />
      <Mui.Skeleton variant="text" width="100%" height={24} />
      <Mui.Skeleton variant="text" width="80%" height={24} />
    </Mui.Stack>

    {/* Preview links */}
    <Mui.Stack direction="row" spacing={1}>
      <Mui.Skeleton variant="rounded" width={60} height={24} />
      <Mui.Skeleton variant="rounded" width={80} height={24} />
    </Mui.Stack>
  </Mui.Box>
);

const AdminSkeleton = () => (
  <Mui.Stack spacing={3}>
    {/* System Message */}
    <Mui.Box>
      <Mui.Skeleton variant="text" width="40%" height={32} />
      <Mui.Skeleton variant="rectangular" width="100%" height={80} />
    </Mui.Box>

    {/* Dates */}
    <Mui.Box>
      <Mui.Box
        display="flex"
        justifyContent="space-between"
        alignItems="flex-end"
        mb={2}
      >
        <Mui.Skeleton variant="text" width="45%" height={40} />
      </Mui.Box>

      {/* Year sections */}
      {[1, 2].map((yearIdx) => (
        <Mui.Box key={yearIdx} sx={{ mb: 3 }}>
          <Mui.Skeleton variant="text" width="15%" height={36} sx={{ mb: 2 }} />

          {/* Period sections */}
          {[1, 2].map((periodIdx) => (
            <SectionLoader key={periodIdx} sx={{ mb: 2 }} />
          ))}
        </Mui.Box>
      ))}
    </Mui.Box>

    {/* Exports */}
    <Mui.Box>
      <Mui.Skeleton variant="text" width="25%" height={32} />
      <Mui.Stack spacing={1}>
        <Mui.Skeleton variant="rectangular" width="100%" height={48} />
        <Mui.Skeleton variant="rectangular" width="100%" height={48} />
      </Mui.Stack>
    </Mui.Box>
  </Mui.Stack>
);

export default AdminSkeleton;
